// extracted by mini-css-extract-plugin
module.exports = {"page_header_branding":"_DMLXl7dA"};